export default __webpack_public_path__ + "static/1096-7b3f40a79599d079e2148a8cef62d67d.gif";